export class IncidentQueueTimeoutError extends Error {
  constructor(public readonly uuid: string) {
    super(`Action with uuid ${uuid} has timed out`)
  }
}
